import { render } from "./RequestCard.vue?vue&type=template&id=511fb93e&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=511fb93e&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511fb93e"]])

export default __exports__